import React, { Fragment, useEffect, useState }  from 'react';
import Swal from 'sweetalert2';

import SideNav from '../../Components/SideNav';
import FormularioAgregar from '../../Components/FormularioAgregar';
import FormularioEditar from '../../Components/FormularioEditar';
import View from './View';

import { useAuth } from '../../Context/Context';

import ProfesoresCursosHelper from '../../Helpers/ProfesoresCursos';
import useStorage from '../../Hooks/useStorage';


const ProfesoresCursos = () => {
    const { editar, setEditar } = useAuth();
    const [file, setFile] = useState({});
    const [urlProfesor, setUrlProfesor] = useState("");

    const [imagen, setImagen] = useState("");
    const [profesores, setProfesor] = useState({
        nombre: "",
        certificado: "",
        imagen: ""
    });

    // uso de hooks para agregar imagen a google storage
    const [consulta, setConsulta] = useState("");
    let [ response ] = useStorage(consulta);

    useEffect(() => {
        if (!response) {
            setProfesor(editar)
        } else {
            if (response.action === 'agregar') {
                agregarProfesor(response.url);
            } else if (response.action === 'actualizar') {
                subirArchivoActualizado(profesores);
            } else if (response.action === 'agregarActualizado') {
                actualizarProfesor(response.url, profesores);
            } else {
                // error
            }
        }
    }, [editar, response]);


    const leerDato = e => {
        console.log({[e.target.name]: e.target.value}, profesores);
        setProfesor({
            ...profesores,
            [e.target.name]: e.target.value
        });
        
    }

    const agregarProfesor = url => {
        profesores.imagen = url;

        ProfesoresCursosHelper.agregarProfesor(profesores);
    }

    const actualizarProfesor = (url, profesores) => {
        console.log({profesores});
        if (url !== "") {
            profesores.imagen = url
        }

        ProfesoresCursosHelper.editarProfesor(profesores, profesores._id);
    }

    const actualizarFoto = e => {
        setFile(e.target.files[0]);

        let fileReader = new FileReader();
        fileReader.addEventListener('load', (evt) => {
            setImagen(fileReader.result);
        });
        fileReader.readAsDataURL(e.target.files[0]);
    }

    const actualizarFotoEditar = e => {
        setFile(e.target.files[0]);
        setUrlProfesor(profesores.imagen);

        
        let fileReader = new FileReader();
        fileReader.addEventListener('load', (evt) => {
            setEditar({
                ...editar,
                [e.target.name]: fileReader.result
            });
        });
        fileReader.readAsDataURL(e.target.files[0]);
    }

    const subirArchivo = e => {
        e.preventDefault();

        setConsulta({consulta:"agregar", name:profesores.nombre, folder:"profesores_cursos/", file, url:"/profesores-cursos"});
    }

    const actualizarArchivo = e => {
        e.preventDefault();

        if (urlProfesor !== "") {
            setConsulta({consulta:"actualizar", url:"/profesores-cursos", urlFile:urlProfesor});
        } else {
            Swal.fire({
                icon: "question",
                title: '¿Esta seguro que desea modificar el profesor?',
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: 'Si',
                denyButtonText: `No`,
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    actualizarProfesor("", profesores);
                } else if (result.isDenied) {
                    Swal.fire(
                        'Modificación cancelada',
                        'El campo quedo intacto' ,
                        'succes'
                    )
                }
            })
        }
    }

    const subirArchivoActualizado = profesores => {
        setConsulta({consulta:"agregarActualizado", name:profesores.nombre, folder:"profesores_cursos/", file});
    }


    return (
        <Fragment>
            <SideNav />
            <div className='row'>
                <FormularioAgregar>
                    <p className='titulo_1_admin'>Información profesor</p>
                    
                    <form onSubmit={subirArchivo}>
                        <div className="input-field">
                            <input onChange={leerDato} id="nombre" name='nombre' type="text" className="validate" />
                            <label for="nombre">Nombre del profesor</label>
                        </div>

                        <div className="input-field">
                            <input onChange={leerDato} id="certificado" name='certificado' type="text" className="validate" />
                            <label for="certificado">Certificado del profesor</label>
                        </div>

                        <p>Imagen</p>
                        <img
                            alt="imagen subida"
                            width="100%"
                            src={imagen}
                        ></img>
                        <div class="file-field input-field">
                            <div class="btn">
                                <span>File</span>
                                <input
                                    name="imagen"
                                    onChange={actualizarFoto}
                                    type="file"
                                    required
                                />
                            </div>
                            <div class="file-path-wrapper">
                                <input
                                    name="imagen"
                                    class="file-path validate"
                                    type="text"
                                    placeholder="Upload one or more files"
                                    required
                                />
                            </div>
                        </div>

                        <div className='botonn_1_admin' style={{marginTop:"10px"}}>
                            <button type='submit'>
                                Agregar profesor
                            </button>
                        </div>
                    </form>
                </FormularioAgregar>
                <FormularioEditar>
                    <p className='titulo_1_admin'>Editar profesor</p>
                    <form onSubmit={actualizarArchivo}>
                        <div className="input-field">
                            <input onChange={leerDato} defaultValue={editar.nombre} id="nombre" name='nombre' type="text" className="validate" />
                            <label className='active' for="nombre">Nombre del profesor</label>
                        </div>

                        <div className="input-field">
                            <input onChange={leerDato} defaultValue={editar.certificado} id="certificado" name='certificado' type="text" className="validate" />
                            <label className='active' for="certificado">Nombre del profesor</label>
                        </div>

                        <img
                            alt="imagen subida"
                            width="100%"
                            src={editar.imagen}
                        ></img>
                        <div class="file-field input-field">
                            <div class="btn">
                                <span>File</span>
                                <input
                                    name="imagen"
                                    onChange={actualizarFotoEditar}
                                    type="file"
                                />
                            </div>
                            <div class="file-path-wrapper">
                                <input
                                    name="imagen"
                                    class="file-path validate"
                                    type="text"
                                    placeholder="Upload one or more files"
                                />
                            </div>
                        </div>

                        <div className='botonn_1_admin' style={{marginTop:"10px"}}>
                            <button type='submit'>
                                Actualizar profesor
                            </button>
                        </div>
                    </form>
                </FormularioEditar>
                <View/>
            </div>
        </Fragment>
    );
}


export default ProfesoresCursos;